import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { showLoader } from "@store/actions/loaderAction";
import { getData } from "@services/apiConfig";
import { runEMUStoredProc, fetchetljobstatus } from '../../constants/endpoints';
import AlertComponent from "../../components/alerts/AlertComponent.js";
import moment from "moment";
import { Table, Select, Space, Card, Button, Typography, Tabs, Divider, TreeSelect } from "antd";
import { DownOutlined } from '@ant-design/icons';
const { Option } = Select;
const { Paragraph, Title } = Typography;
const { TabPane } = Tabs;
const { TreeNode } = TreeSelect;


const EmuCalculation = () => {

    const dispatch = useDispatch();
    const [user, setUser] = useState({});
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [updatedDate, setUpdatedDate] = useState("-")
    const [activeTab, setActiveTab] = useState('1');
    const [activeViewTab, setActiveViewTab] = useState('1');
    const [activeMastersViewTab, setActiveMastersViewTab] = useState('1');
    const [isViewTabEnabled, setIsViewTabEnabled ]= useState(false);
    const [selectedLocation, setSelectedLocation] = useState(['Zimbabwe']);
    const [selectedSingleLocation, setSelectedSingleLocation] = useState('Zimbabwe');
    const [timeFilterS1, setTimeFilterS1] = useState('yearly');
    const [timeFilterS2, setTimeFilterS2] = useState('yearly');
    const [columnsS1, setColumnsS1] = useState([]);
    const [columnsS2, setColumnsS2] = useState([]);
    // const [columnsS3, setColumnsS3] = useState([]);
    const [countryYearlyData, setCountryYearlyData] = useState([]);
    const [provinceYearlyData, setProvinceYearlyData] = useState([]);
    const [countryMonthlyData, setCountryMonthlyData] = useState([]);
    const [provinceMonthlyData, setProvinceMonthlyData] = useState([]);
    const [countryYearlyVisitsData, setCountryYearlyVisitsData] = useState([]);
    const [countryYearlyClientsData, setCountryYearlyClientsData] = useState([]);
    const [provinceYearlyVisitsData, setProvinceYearlyVisitsData] = useState([]);
    const [provinceYearlyClientsData, setProvinceYearlyClientsData] = useState([]);
    const [countryMonthlyVisitsData, setCountryMonthlyVisitsData] = useState([]);
    const [countryMonthlyClientsData, setCountryMonthlyClientsData] = useState([]);
    const [provinceMonthlyVisitsData, setProvinceMonthlyVisitsData] = useState([]);
    const [provinceMonthlyClientsData, setProvinceMonthlyClientsData] = useState([]);
    const [countryYearlyFacilityData, setCountryYearlyFacilityData] = useState([]);
    const [provinceYearlyFacilityData, setProvinceYearlyFacilityData] = useState([]);
    const [countryMonthlyFacilityData, setCountryMonthlyFacilityData] = useState([]);
    const [provinceMonthlyFacilityData, setProvinceMonthlyFacilityData] = useState([]);
    const [populationScreenData, setPopulationScreenData ] = useState([]);
    const [masterSectorData, setMasterSectorData] = useState([]);
    const [masterCypData, setMasterCypData] = useState([]);
    const [masterCrData, setMasterCrData] = useState([]);
    const [filteredDataS1, setFilteredDataS1] = useState([]);
    const [filteredDataS2, setFilteredDataS2] = useState([]);
    const [DataS4_3, setDataS4_3] = useState([]);
    const [sourceSystem, setSourceSystem] = useState("DHIS2");
    const [category, setCategory] = useState("Visit");
    const [loadedTabs, setLoadedTabs] = useState({}); 
    const [treeValue, setTreeValue] = useState(null);

    

    const userDetailReducer = useSelector(
        (state) => state.basicConfigReducer.userdetails
    );

    useEffect(() => {
        setUser(userDetailReducer);
    }, [userDetailReducer]);

    useEffect(() => {
        const fetchETLJobstatus = async () => {
            try {
                // dispatch(showLoader(true));

                const payload = { url: fetchetljobstatus };
                let res = await getData(payload);


                if (res.status === 200 && res.data) {
                    let update = moment(res.data.lastupdated_date).format("DD-MM-YYYY hh:mm:ss A");
                    setUpdatedDate(update);
                    setIsButtonDisabled(res.data.active_flag === 'Y');
                }
            } catch (err) {
                console.log("error", err);
            } finally {
                dispatch(showLoader(false));
            }
        };

        fetchETLJobstatus();
    }, []); 

    
    const isMicroServices = useSelector(
    (state) => state.basicConfigReducer.isMicroServices
    );

    const handleCalculate = async () => {
        dispatch(showLoader(true));
        setIsViewTabEnabled(true)
        try {
            const payload = {
                url: `${isMicroServices ? "odcMdmService/" : ""}${runEMUStoredProc}`,
                service: "baseJava",
                toUAT: true,
            };
            await getData(payload);
            dispatch(showLoader(false));
            AlertComponent({
                type: "success",
                title: "Success",
                text: "The procedure calculator is now running.",
                icon: "success",
                onConfirm: () => {
                    // Disable the calculate button when the alert is confirmed
                    setIsButtonDisabled(true);

                },
            });

        } catch (err) {
            console.log("error", err)
            AlertComponent({
                type: "error",
                title: "Error",
                text: "Some Error Occured while executing the procedure.Please try again.",
                icon: "success",
            });
        }

    }

    const handleTabChange = (key) => {
    if (key === "2" && !setIsViewTabEnabled){
    return; 
    }
    setActiveTab(key);
    };

    const handleInnerTabChange = (key) => {
    setActiveViewTab(key);
    };

    const yearlyColumnsS1 = [
        {
            title: 'Year',
            dataIndex: 'year',
            key: 'year',
            width: '10%',
        },
        {
            title: 'Location',
            dataIndex: 'location_name',
            key: 'location_name',
            width: '20%',
        },
        {
            title: 'EMU Visit',
            dataIndex: 'EMU Visit',    // Updated to match API response
            key: 'emu_visit',
            width: '15%',
        },
        {
            title: 'EMU Clients',
            children: [
                {
                    title: 'With Condom',
                    dataIndex: 'EMU Client - With Condom',    // Updated to match API response
                    key: 'emu_client_with_condom',
                    width: '15%',
                },
                {
                    title: 'Without Condom',
                    dataIndex: 'EMU Client - Without Condom',    // Updated to match API response
                    key: 'emu_client_without_condom',
                    width: '15%',
                },
            ]
        },
        {
            title: 'EMU Facility',
            dataIndex: 'EMU Facility',    // Updated to match API response
            key: 'emu_facility',
            width: '15%',
        }
    ];

    const monthlyColumnsS1 = [
        {
            title: 'Year',
            dataIndex: 'year',
            key: 'year',
            width: '10%',
        },
        {
            title: 'Month',
            dataIndex: 'month',
            key: 'month',
            width: '10%',
        },
        {
            title: 'Location',
            dataIndex: 'location_name',
            key: 'location_name',
            width: '15%',
        },
        {
            title: 'EMU Visit',
            dataIndex: 'EMU Visit',    // Updated to match API response
            key: 'emu_visit',
            width: '15%',
        },
        {
            title: 'EMU Clients',
            children: [
                {
                    title: 'With Condom',
                    dataIndex: 'EMU Client - With Condom',   
                    key: 'emu_client_with_condom',
                    width: '15%',
                },
                {
                    title: 'Without Condom',
                    dataIndex: 'EMU Client - Without Condom',    
                    key: 'emu_client_without_condom',
                    width: '15%',
                }
            ]
        },
        {
            title: 'EMU Facility',
            dataIndex: 'EMU Facility',    // Updated to match API response
            key: 'emu_facility',
            width: '15%',
        }
    ];

    

    const countryYearly = async () => {
        try {
            const url = "fetch-emu-country-yearly";
            return await getData({ url });
        } catch (error) {
            console.error("Error fetching country yearly data:", error);
            throw error;
        }
    };

    const countryMonthly = async () => {
        try {
            const url = "fetch-emu-country-monthly";
            return await getData({ url });
        } catch (error) {
            console.error("Error fetching country monthly data:", error);
            throw error;
        }
    };

    const provinceYearly = async () => {
        try {
            const url = "fetch-emu-province-yearly";
            return await getData({ url });
        } catch (error) {
            console.error("Error fetching province yearly data:", error);
            throw error;
        }
    };

    const provinceMonthly = async () => {
        try {
            const url = "fetch-emu-province-monthly";
            return await getData({ url });
        } catch (error) {
            console.error("Error fetching province monthly data:", error);
            throw error;
        }
    };

    const countryYearlyVisits = async () => {
        try {
            const url = "fetch-emu-country-yearly-visits";
            return await getData({ url });
        } catch (error) {
            console.error("Error fetching country yearly visits data:", error);
            throw error;
        }
    };

    const countryYearlyClients = async () => {
        try {
            const url = "fetch-emu-country-yearly-clients";
            return await getData({ url });
        } catch (error) {
            console.error("Error fetching country yearly clients data:", error);
            throw error;
        }
    };

    const provinceYearlyVisits = async () => {
        try {
            const url = "fetch-emu-province-yearly-visits";
            return await getData({ url });
        } catch (error) {
            console.error("Error fetching province yearly visits data:", error);
            throw error;
        }
    };

    const provinceYearlyClients = async () => {
        try {
            const url = "fetch-emu-province-yearly-clients";
            return await getData({ url });
        } catch (error) {
            console.error("Error fetching province yearly clients data:", error);
            throw error;
        }
    };

    const countryMonthlyVisits = async () => {
        try {
            const url = "fetch-emu-country-monthly-visits";
            return await getData({ url });
        } catch (error) {
            console.error("Error fetching country monthly visits data:", error);
            throw error;
        }
    };

    const countryMonthlyClients = async () => {
        try {
            const url = "fetch-emu-country-monthly-clients";
            return await getData({ url });
        } catch (error) {
            console.error("Error fetching country monthly clients data:", error);
            throw error;
        }
    };

    const provinceMonthlyVisits = async () => {
        try {
            const url = "fetch-emu-province-monthly-visits";
            return await getData({ url });
        } catch (error) {
            console.error("Error fetching province monthly visits data:", error);
            throw error;
        }
    };

    const provinceMonthlyClients = async () => {
        try {
            const url = "fetch-emu-province-monthly-clients";
            return await getData({ url });
        } catch (error) {
            console.error("Error fetching province monthly clients data:", error);
            throw error;
        }
    };

    const populationScreen = async () => {
        try {
            const url = "population-master";
            return await getData({ url });
        } catch (error) {
            console.error("Error fetching population master data:", error);
            throw error;
        }
    };


    const masterSectorScreen = async () => {
        try {
            const url = "sector-master";
            return await getData({ url });
        } catch (error) {
            console.error("Error fetching population master data:", error);
            throw error;
        }
    }

    const masterCypScreen = async () =>{
        try {
            const url = "cyp-master";
            return await getData({ url });
        } catch (error) {
            console.error("Error fetching population master data:", error);
            throw error;
        }
    }

    const masterCrScreen = async() =>{
        try {
            const url = "cr-master";
            return await getData({ url });
        } catch (error) {
            console.error("Error fetching population master data:", error);
            throw error;
        }
    }

    const populateDataS1 = async () => {
        try {
            const fetchedCountryYearlyData = await countryYearly();
            const fetchedProvinceYearlyData = await provinceYearly();
            const fetchedCountryMonthlyData = await countryMonthly();
            const fetchedProvinceMonthlyData = await provinceMonthly();
            

            // Update state with fetched data
            setCountryYearlyData(fetchedCountryYearlyData?.data || []);
            setProvinceYearlyData(fetchedProvinceYearlyData?.data || []);
            setCountryMonthlyData(fetchedCountryMonthlyData?.data || []);
            setProvinceMonthlyData(fetchedProvinceMonthlyData?.data || []);
        } catch (error) {
            console.error("Error populating data:", error);
        }
    };

    const populateDataS2 = async () => {
        try {
            const fetchedCountryYearlyVisitsData = await countryYearlyVisits();
            const fetchedCountryYearlyClientsData = await countryYearlyClients();
            const fetchedProvinceYearlyVisitsData = await provinceYearlyVisits();
            const fetchedProvinceYearlyClientsData = await provinceYearlyClients();
            const fetchedCountryMonthlyVisitsData = await countryMonthlyVisits();
            const fetchedCountryMonthlyClientsData = await countryMonthlyClients();
            const fetchedProvinceMonthlyVisitsData = await provinceMonthlyVisits();
            const fetchedProvinceMonthlyClientsData = await provinceMonthlyClients();

            setCountryYearlyVisitsData(fetchedCountryYearlyVisitsData?.data || []);
            setCountryYearlyClientsData(fetchedCountryYearlyClientsData?.data || []);
            setProvinceYearlyVisitsData(fetchedProvinceYearlyVisitsData?.data || []);
            setProvinceYearlyClientsData(fetchedProvinceYearlyClientsData?.data || []);
            setCountryMonthlyVisitsData(fetchedCountryMonthlyVisitsData?.data || []);
            setCountryMonthlyClientsData(fetchedCountryMonthlyClientsData?.data || []);
            setProvinceMonthlyVisitsData(fetchedProvinceMonthlyVisitsData?.data || []);
            setProvinceMonthlyClientsData(fetchedProvinceMonthlyClientsData?.data || []);
        } catch (error) {
            console.error("Error populating data:", error);
        }
    };

    const populateDataS3 = async()=>{
        try{
            const fetchPopulationScreenData = await populationScreen();
            setPopulationScreenData(fetchPopulationScreenData?.data || [])

        }
        catch(error){
            console.error("Error populating S3 data:", error);
        }
    }


    const populateDataS4 = async() => {
        try {
            const fetchMasterSectors = await masterSectorScreen();
            const fetchMastersCyp = await masterCypScreen();
            const fetchMastersCr = await masterCrScreen();
            setMasterSectorData(fetchMasterSectors?.data || [])
            setMasterCypData(fetchMastersCyp?.data || [])
            setMasterCrData(fetchMastersCr?.data || [])
            
        }
        catch (error) {
            console.error("Error populating S4 data:", error);
        }
    }

    const fetchData = (viewTab) => {
        if (viewTab === '1') return populateDataS1();
        if (viewTab === '2') return populateDataS2();
        if (viewTab === '3') return populateDataS3();
        if (viewTab === '4') return populateDataS4();

        return Promise.resolve(); // Default case to prevent errors
    };

    useEffect(() => {
        if (activeTab === '2') {
            const key = `${activeTab}-${activeViewTab}`;

            if (!loadedTabs[key]) { // Load only if not already loaded
                dispatch(showLoader(true));

                fetchData(activeViewTab)
                    .then(() => {
                        setLoadedTabs(prev => ({ ...prev, [key]: true })); // Mark as loaded
                    })
                    .finally(() => {
                        dispatch(showLoader(false));
                    });
            }
        }
    }, [activeTab, activeViewTab, loadedTabs, dispatch]);


    const handleTimeFilterChangeS1 = (value) => {
        setTimeFilterS1(value);
    };

    const handleLocationFilterChange = (values) => {
        const isZimbabweSelected = values.includes("Zimbabwe");
        if (values[values.length - 1] === "Zimbabwe") {
            values = ["Zimbabwe"];
        }
        
        else if 
        (isZimbabweSelected && values.length > 1) {
            values = values.filter(val => val !== "Zimbabwe");
        }
        
        else if (values.length === 0) {
            values = ["Zimbabwe"];
        }
        setSelectedLocation(values);
    };

    const handleSourceSystemChange = (value) => {
        setSourceSystem(value);
    };

    const handleCategoryChange = (value) => {
        setCategory(value);
    };

    const handleLocationChangeSingle = (value) => {
        setSelectedSingleLocation(value);
    }

    useEffect(() => {
        let selectedData;

        if (timeFilterS1 === 'yearly') {
            if (selectedLocation.includes("Zimbabwe")) {
                selectedData = countryYearlyData; 
            } else if (selectedLocation.includes("Provinces")) {
                selectedData = provinceYearlyData
            }
            else{
                selectedData = provinceYearlyData.filter(item => selectedLocation.includes(item.location_name));
             
            }
            setColumnsS1(yearlyColumnsS1);
        } else {
            if (selectedLocation.includes("Zimbabwe")) {
                selectedData = countryMonthlyData;
            } 
            else if (selectedLocation.includes("Provinces")) {
                selectedData = provinceMonthlyData
            } 
            else {
                selectedData = provinceMonthlyData.filter(item => selectedLocation.includes(item.location_name));
            }
            setColumnsS1(monthlyColumnsS1);
        }

        setFilteredDataS1(selectedData);
    }, [timeFilterS1, selectedLocation, countryYearlyData, countryMonthlyData, provinceYearlyData, provinceMonthlyData]);

    const methodOrder = [
        { method: "Sterilization", subMethods: ["Tubal Ligation (F)", "Vasectomy (M)"] },
        { method: "IUD", subMethods: ["Copper- T 380-A IUD", "Hormonal IUD (LNG-IUS)"] },
        { method: "Implant", subMethods: ["3 Year Implant (Implanon, Levoplant)", "4 Year Implant", "5 Year Implant (Jadelle)"] },
        { method: "Injectable", subMethods: ["Depo Provera (DMPA)", "Sayana Press", "Other Injectable"] },
        { method: "Pill", subMethods: ["Combined Oral (COC)", "Progestin only (POP)"] },
        { method: "Condom", subMethods: ["Male Condom"] },
        { method: "Other Modern Methods", subMethods: ["LAM"] },
        { method: "Emergency contraception", subMethods: ["EC"] },
    ];

    const methodMapping = {
        "Tubal Ligation (F)": "Tubal Ligation (F)",
        "Vasectomy (M)": "Vasectomy (M)",
        "Copper- T 380-A IUD": "Copper- T 380-A IUD",
        "LNG-IUS": "Hormonal IUD (LNG-IUS)",
        "Implanon": "3 Year Implant (Implanon, Levoplant)",
        "4 Year Implant": "4 Year Implant",
        "Jadelle": "5 Year Implant (Jadelle)",
        "Depo Provera (DMPA)": "Depo Provera (DMPA)",
        "Sayana Press": "Sayana Press",
        "Other Injectable": "Other Injectable",
        "Combined Oral": "Combined Oral (COC)",
        "Progestin only": "Progestin only (POP)",
        "Male Condom": "Male Condom",
        "LAM": "LAM",
        "EC": "EC"
    }
    const handleTimeFilterChangeS2 = (value) => {
        setTimeFilterS2(value);
    };

   
    

    useEffect(() => {
        let rawData = [];
        

        if (category === 'Visit') {
            rawData = timeFilterS2 === 'yearly' ? [...countryYearlyVisitsData, ...provinceYearlyVisitsData] : [...countryMonthlyVisitsData, ...provinceMonthlyVisitsData];
        } else if (category === 'Client') {
            rawData = timeFilterS2 === 'yearly' ? [...countryYearlyClientsData, ...provinceYearlyClientsData] : [...countryMonthlyClientsData, ...provinceMonthlyClientsData];
        } else if (category === 'Facility') {
            rawData = timeFilterS2 === 'yearly' ? [...countryYearlyFacilityData, ...provinceYearlyFacilityData] : [...countryMonthlyFacilityData, ...provinceMonthlyFacilityData];
        }

   

        if (selectedSingleLocation) {
            rawData = rawData.filter(row => row.location_name.toLowerCase() === selectedSingleLocation.toLowerCase());
        }

        if (sourceSystem) {
            rawData = rawData.filter(row => row.Application_name === sourceSystem);
        }

        

        // Step 1: Compute dynamic time columns
        const dynamicColumns = [];
        const now = moment();

        if (timeFilterS2 === 'yearly') {
            for (let i = 0; i < 10; i++) {
                const year = now.clone().subtract(i, 'years').format('YYYY');
                dynamicColumns.push({ title: year, dataIndex: year, key: year, align: 'center' });
            }
        } else if (timeFilterS2.startsWith('monthly')) {
            
            const monthCount = timeFilterS2.includes('-') ?
                parseInt(timeFilterS2.split('-')[1]) :
                12; 

            
            for (let i = 0; i < monthCount; i++) {
                const monthYear = now.clone().subtract(i, 'months').format('YYYY-MM');
                dynamicColumns.push({
                    title: monthYear,
                    dataIndex: monthYear,
                    key: monthYear,
                    align: 'center'
                });
            }
        }

        // Step 2: Initialize pivotData with all methods and sub-methods
        const pivotData = {};

        methodOrder.forEach(({ method, subMethods }) => {
            subMethods.forEach(subMethod => {
                pivotData[`${method}-${subMethod}`] = {
                    key: `${method}-${subMethod}`,
                    location: selectedSingleLocation || "N/A",
                    method,
                    subMethod,
                    ...Object.fromEntries(dynamicColumns.map(col => [col.dataIndex, "-"])) // Default values for time columns
                };
            });
        });

        // Step 3: Merge actual data into pivotData
        rawData.forEach(row => {
            const method = row.Method;
            const subMethod = methodMapping[row.SubMethod] || row.SubMethod;
            const key = `${method}-${subMethod}`;

            if (!pivotData[key]) {
                pivotData[key] = {
                    key,
                    location: row.location_name,
                    method,
                    subMethod,
                    ...Object.fromEntries(dynamicColumns.map(col => [col.dataIndex, "-"]))
                };
            }

            const timeKey = timeFilterS2 === 'yearly' ? row.year : `${row.year}-${String(row.month).padStart(2, '0')}`;
            pivotData[key][timeKey] = row.total_commodities_client || 0;
        });

        // Step 4: Convert pivotData to array and sort it
        const sortedData = Object.values(pivotData).sort((a, b) => {
            const methodIndexA = methodOrder.findIndex(item => item.method === a.method);
            const methodIndexB = methodOrder.findIndex(item => item.method === b.method);

            if (methodIndexA !== methodIndexB) return methodIndexA - methodIndexB;

            const subMethodsA = methodOrder[methodIndexA]?.subMethods || [];
            const subMethodsB = methodOrder[methodIndexB]?.subMethods || [];

            const subMethodIndexA = subMethodsA.indexOf(a.subMethod);
            const subMethodIndexB = subMethodsB.indexOf(b.subMethod);

            return subMethodIndexA - subMethodIndexB;
        });

        setColumnsS2([
            { title: 'Location', dataIndex: 'location', key: 'location', fixed: 'left' },
            { title: 'Method', dataIndex: 'method', key: 'method', fixed: 'left' },
            { title: 'Sub-method', dataIndex: 'subMethod', key: 'subMethod', fixed: 'left' },
            ...dynamicColumns
        ]);

        setFilteredDataS2(sortedData);
    }, [
        countryYearlyVisitsData, countryMonthlyVisitsData, provinceYearlyVisitsData, provinceMonthlyVisitsData,
        countryYearlyClientsData, countryMonthlyClientsData, provinceYearlyClientsData, provinceMonthlyClientsData,
        timeFilterS2, selectedSingleLocation, sourceSystem, category,
        countryYearlyFacilityData, provinceYearlyFacilityData, countryMonthlyFacilityData, provinceMonthlyFacilityData
    ]);


    //---------------------------------------------------------------------------------------------
    const currentYear3 = new Date().getFullYear();
    const years3= Array.from({ length: currentYear3 - 2007 }, (_, i) => currentYear3 - i);
    const locationMap = {};

    populationScreenData.forEach(({ location_name, year, value }) => {
        if (!locationMap[location_name]) {
            locationMap[location_name] = { key: location_name, location_name };
        }
        locationMap[location_name][year] = value;
    });

    const DataS3 = Object.values(locationMap);

    const columnsS3 = [
        { title: "Location Name", dataIndex: "location_name", key: "location_name", fixed: "left" },
        ...years3.map(year => ({
            title: year.toString(),
            dataIndex: year.toString(),
            key: year.toString(),
            render: (text) => text || "-", // Show "-" if no data available
        })),
    ];

    //------------------------------------------------------------------------------------------

    const sectorMapping = {
        "Public Sector": ["Government Health Facilities and Home/Community Delivery"],
        "Private Medical Sector": ["NGO", "Private Hospital/Clinic Delivery", "Pharmacy"],
        "Other Source": ["Shop/Church/Friend", "Other"]
    };
    
    const columnsS4_1 = [
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            fixed: 'left',
        },
        
        ...Object.keys(sectorMapping).map(sectorType => ({
            title: sectorType,
            children: sectorMapping[sectorType].map(subColumn => ({
                title: subColumn,
                dataIndex: `${sectorType}_${subColumn}`,
                key: `${sectorType}_${subColumn}`,
                align: 'center',
            }))
        }))
    ];

    const fixedRows = [
        "Contraceptive commodities distributed to clients",
        "Contraceptive commodities distributed to facilities",
        "FP Visits",
        "FP Users"
    ];

    const categoryMapping = {
        "Commodities_Client": "Contraceptive commodities distributed to clients",
        "Visits": "FP Visits",
        "Commodities_Facility": "Contraceptive commodities distributed to facilities"
    };


    const valueMapping = {
        "0%": 0,
        "50%": 0.5,
        "100%": 1
    };
    
    const DataS4_1 = fixedRows.map(category => {
        const row = { category };
      
        masterSectorData.forEach(item => {
            const mappedCategory = categoryMapping[item.data_type];
            if (mappedCategory === category) {
                const columnKey = `${item.sector_type}_${item.sector_name}`;
                row[columnKey] = valueMapping[item.value] ?? '';
            }
        });

        return row;
    });

    const methodStructure = {
        Sterilization: ["Tubal Ligation (F)", "Vasectomy (M)"],
        IUD: ["Copper- T 380-A IUD", "Hormonal IUD (LNG-IUS)"],
        Implant: [
            "3 Year Implant (Implanon, Levoplant)",
            "4 Year Implant (Sino-Implant)",
            "5 Year Implant (Jadelle)"
        ],
        Injectable: [
            "Depo Provera (DMPA)",
            "Noristerat (NET-En)",
            "Lunelle",
            "Sayana Press",
            "Other Injectable"
        ],
        Pill: ["Combined Oral (COC)", "Progestin only (POP)", "Other OC Pill"],
        Condom: ["Male Condom", "Female Condom"],
        "Other Modern Methods": [
            "LAM",
            "SDM (Standard Days)",
            "Vaginal barrier",
            "Spermicides"
        ],
        "Emergency contraception": ["EC"]
    };

    const subMethodMapping = {
        "Tubal Ligation (F)": "Tubal Ligation (F)",
        "Vasectomy (M)": "Vasectomy (M)",
        "Copper- T 380-A IUD": "Copper- T 380-A IUD",
        "LNG-IUS": "Hormonal IUD (LNG-IUS)",
        "Implanon": "3 Year Implant (Implanon, Levoplant)",
        "Jadelle": "5 Year Implant (Jadelle)",
        "Sino-Implant": "4 Year Implant (Sino-Implant)",
        "Depo Provera (DMPA)": "Depo Provera (DMPA)",
        "Noristerat (NET-En)": "Noristerat (NET-En)",
        "Lunelle": "Lunelle",
        "Sayana Press": "Sayana Press",
        "Other Injectable": "Other Injectable",
        "Combined Oral": "Combined Oral (COC)",
        "Progestin only": "Progestin only (POP)",
        "Other OC Pill": "Other OC Pill",
        "Male Condom": "Male Condom",
        "Female Condom": "Female Condom",
        "LAM": "LAM",
        "SDM (Standard Days)": "SDM (Standard Days)",
        "Vaginal barrier": "Vaginal barrier",
        "Spermicides": "Spermicides",
        "EC": "EC"
    };



    const columnsS4_2 = [
        {
            title: "Method",
            dataIndex: "method",
            key: "method",
        },
        {
            title: "Submethod",
            dataIndex: "subMethod",
            key: "subMethod",
        },
        {
            title: "CYP Factor",
            dataIndex: "cyp",
            key: "cyp",
        },
    ];
    const DataS4_2 = [];

    Object.entries(methodStructure).forEach(([method, subMethods]) => {
        subMethods.forEach((displayName) => {
            // Find which key in subMethodMapping maps to this displayName
            const rawSubMethod = Object.keys(subMethodMapping).find(
                (key) => subMethodMapping[key] === displayName
            );

            const matched = masterCypData.find(
                (item) => item.SubMethod === rawSubMethod
            );

            const rawCyp = matched ? matched.cyp_factor1_visit : 0;

            DataS4_2.push({
                key: `${method}-${displayName}`,
                method,
                subMethod: displayName, // use display name for UI
                cyp: Math.round(rawCyp * 100) / 100, // ✅ rounded to 2 decimal places
                method_id: matched ? matched.method_id : null,
            });
        });
    });



    const columnsS4_3 = [
        {
            title: 'Method',
            dataIndex: 'Method',
            key: 'Method',
            fixed: 'left',
        },
        {
            title: 'Sub-method',
            dataIndex: 'SubMethod',
            key: 'SubMethod',
            fixed: 'left',
        },
        {
            title: 'Continuation Rate',
            children: Array.from({ length: 12 }, (_, i) => ({
                title: `Year ${i}`,
                dataIndex: `yr_${i}`,
                key: `yr_${i}`,
            })),
        },
    ];

    
    const getOrderedData = (rawData) => {
        const yearKeys = Array.from({ length: 12 }, (_, i) => `yr_${i}`);

        // Normalize data and build a map for quick lookup
        const normalizedMap = new Map();

        rawData.forEach((item) => {
            const mappedSub = subMethodMapping[item.SubMethod] || item.SubMethod;
            const key = `${item.Method}-${mappedSub}`;
            normalizedMap.set(key, item);
        });

        // Flatten the method structure into a fixed list
        const fixedList = [];

        Object.entries(methodStructure).forEach(([method, subMethods]) => {
            subMethods.forEach((sub) => {
                const key = `${method}-${sub}`;
                const original = normalizedMap.get(key);

                const row = {
                    key,
                    Method: method,
                    SubMethod: sub
                };

                yearKeys.forEach((yr) => {
                    let val = original ? original[yr] : null;
                    row[yr] = val !== null && val !== undefined ? Number(val.toFixed(2)) : "-";
                });

                fixedList.push(row);
            });
        });

        return fixedList;
    };

    useEffect(() => {
        if (masterCrData.length) {
            const ordered = getOrderedData(masterCrData);
            setDataS4_3(ordered);
        }
    }, [masterCrData]);



    return (
       <>
            <Tabs activeKey={activeTab} onChange={handleTabChange}> 
            <TabPane tab="Procedure Calculator" key="1">
            <Card>
                <Paragraph>
                The calculator below performs calculations for the specified methods.
                </Paragraph>
                <Paragraph>
                Note: Once the calculator is running, the button will remain inactive until the procedure is complete.
                </Paragraph>
                <ul>
                <li>EMU Calculations</li>
                <li>Financial Year Calculation</li>
                <li>Reporting Rate Bench Mark Calculation</li>
                <li>Standard Deviation Calculation</li>
                <li>Coefficient of Determination (R²) Calculation</li>
                </ul>
                <Button 
                type="primary" 
                style={{ marginTop: '16px' }} 
                onClick={handleCalculate} 
                disabled={isButtonDisabled}
                >
                Calculate
                </Button>
            </Card>
            <div style={{ marginTop: '16px' }}>
            <Card title="Procedure Calculator Logs">
            <Paragraph>
                Last Executed Procedure Date: {updatedDate || "Not available"}
            </Paragraph>
            </Card>
            </div>
            </TabPane>
            
            {/* {isViewTabEnabled && ( */}
            <TabPane tab="View EMU Data" key="2">
            <Card>
                <Tabs activeKey={activeViewTab} onChange={handleInnerTabChange}>

                {/* EMU OUTPUT TAB */}   
                <TabPane tab="EMU Output" key="1">
                    <Space direction="horizontal" size="middle" className="mb-4">
                        <Space>
                            <span>Location:</span>
                            <TreeSelect
                                value={selectedLocation}
                                onChange={handleLocationFilterChange}
                                treeCheckable={true} // Allows multiple selections
                                showCheckedStrategy={TreeSelect.SHOW_PARENT}
                                placeholder="Select Location"
                                style={{ width: 250 }}
                            >
                                {/* Top-level option for Zimbabwe */}
                                <TreeNode value="Zimbabwe" title="Zimbabwe" />

                                {/* Provinces as child nodes */}
                                <TreeNode value="Provinces" title="Provinces" selectable={false}>
                                    <TreeNode value="me Mashonaland East Province" title="Mashonaland East Province" />
                                    <TreeNode value="bu Bulawayo Central Hospitals" title="Bulawayo Central Hospitals" />
                                    <TreeNode value="mc Mashonaland Central Province" title="Mashonaland Central Province" />
                                    <TreeNode value="mn Matabeleland North Province" title="Matabeleland North Province" />
                                    <TreeNode value="mv Masvingo Province" title="Masvingo Province" />
                                    <TreeNode value="mw Mashonaland West Province" title="Mashonaland West Province" />
                                    <TreeNode value="bu Bulawayo Province" title="Bulawayo Province" />
                                    <TreeNode value="ma Manicaland Province" title="Manicaland Province" />
                                    <TreeNode value="ha Harare Province" title="Harare Province" />
                                    <TreeNode value="mi Midlands Province" title="Midlands Province" />
                                    <TreeNode value="ms Matabeleland South Province" title="Matabeleland South Province" />
                                </TreeNode>
                            </TreeSelect>
                        </Space>

                        <Space>
                            <span>Time Period:</span>
                            <Select
                                value={timeFilterS1}
                                onChange={handleTimeFilterChangeS1}
                                style={{ width: 120 }}
                                suffixIcon={<DownOutlined />}
                            >
                                <Option value="yearly">Yearly</Option>
                                <Option value="monthly">Monthly</Option>
                            </Select>
                        </Space>
                    </Space>

                    <Table
                        columns={columnsS1}
                        dataSource={filteredDataS1}
                        bordered
                        pagination={{ pageSize: 10 }}
                        size="middle"
                        scroll={{ x: 'max-content' }}
                        style={{ marginTop: '20px' }}
                    />
                </TabPane>

                {/* INPUT DATA TAB */}
                <TabPane tab="Input data Screen" key="2">
                    <Space direction="horizontal" size="middle" className="mb-4">
                        <Space>
                            <span>Location:</span>
                            <TreeSelect
                                value={selectedSingleLocation}
                                onChange={handleLocationChangeSingle}
                                placeholder="Select Location"
                                style={{ width: 250 }}
                            >
                                {/* Top-level option for Zimbabwe */}
                                <TreeNode value="Zimbabwe" title="Zimbabwe" />

                                {/* Provinces as child nodes */}
                                <TreeNode value="Provinces" title="Provinces" selectable={false}>
                                    <TreeNode value="me Mashonaland East Province" title="Mashonaland East Province" />
                                    <TreeNode value="bu Bulawayo Central Hospitals" title="Bulawayo Central Hospitals" />
                                    <TreeNode value="mc Mashonaland Central Province" title="Mashonaland Central Province" />
                                    <TreeNode value="mn Matabeleland North Province" title="Matabeleland North Province" />
                                    <TreeNode value="mv Masvingo Province" title="Masvingo Province" />
                                    <TreeNode value="mw Mashonaland West Province" title="Mashonaland West Province" />
                                    <TreeNode value="bu Bulawayo Province" title="Bulawayo Province" />
                                    <TreeNode value="ma Manicaland Province" title="Manicaland Province" />
                                    <TreeNode value="ha Harare Province" title="Harare Province" />
                                    <TreeNode value="mi Midlands Province" title="Midlands Province" />
                                    <TreeNode value="ms Matabeleland South Province" title="Matabeleland South Province" />
                                </TreeNode>
                            </TreeSelect>
                        </Space>

                        {<Space>
                            <span>Time Period:</span>
                            <TreeSelect
                                style={{ width: 200 }}
                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                placeholder="Select time period"
                                treeDefaultExpandAll
                                value={timeFilterS2}
                                onChange={handleTimeFilterChangeS2}
                                suffixIcon={<DownOutlined />}
                                treeData={[
                                    {
                                        title: 'Yearly',
                                        value: 'yearly',
                                        key: 'yearly',
                                    },
                                    {
                                        title: 'Monthly',
                                        value: 'monthly',
                                        key: 'monthly',
                                        children: [
                                            {
                                                title: 'Last 12 months',
                                                value: 'monthly-12',
                                                key: 'monthly-12',
                                            },
                                            {
                                                title: 'Last 24 months',
                                                value: 'monthly-24',
                                                key: 'monthly-24',
                                            },
                                            {
                                                title: 'Last 36 months',
                                                value: 'monthly-36',
                                                key: 'monthly-36',
                                            },
                                            {
                                                title: 'Last 48 months',
                                                value: 'monthly-48',
                                                key: 'monthly-48',
                                            },
                                            {
                                                title: 'Last 60 months',
                                                value: 'monthly-60',
                                                key: 'monthly-60',
                                            },
                                        ],
                                    },
                                ]}
                            />
                        </Space>}

                        {/* Source Systems Filter */}
                        <Space>
                            <span>Source Systems:</span>
                            <Select
                                value={sourceSystem}
                                onChange={handleSourceSystemChange}
                                style={{ width: 150 }}
                                placeholder="Select Source"
                            >
                                <Option value="DHIS2">DHIS2</Option>
                                <Option value="PSH">PSH</Option>
                                <Option value="PSZ">PSZ</Option>
                                <Option value="NatPharm">NatPharm</Option>
                                <Option value="ZNFPC">ZNFPC</Option>
                            </Select>
                        </Space>

                        {/* Category Filter */}
                        <Space>
                            <span>Category:</span>
                            <Select
                                value={category}
                                onChange={handleCategoryChange}
                                style={{ width: 150 }}
                                placeholder="Select Category"
                            >
                                <Option value="Visit">Visit</Option>
                                <Option value="Client">Client</Option>
                                <Option value="Facility">Facility</Option>
                            </Select>
                        </Space>
                    </Space>
                    <Table
                        columns={columnsS2}
                        dataSource={filteredDataS2}
                        bordered
                        pagination={{ pageSize: 10 }}
                        size="middle"
                        scroll={{ x: 'max-content' }}
                        style={{ marginTop: '20px' }}
                    />
                </TabPane>

                {/* POPULATION TAB */}             
                <TabPane tab="Population Screen" key="3">
                    <Table
                        columns={columnsS3}
                        dataSource={DataS3}
                        bordered
                        scroll={{ x: "max-content" }} // Ensures all columns are visible
                    />
                </TabPane>

                {/* MASTER TAB  */}
                <TabPane tab="Master Screen" key="4">
                    {/* Sub Tabs Inside Master Screen */}
                    <Tabs activeKey={activeMastersViewTab} onChange={setActiveMastersViewTab} type="card">
                        {/* Sector and Sub-sector Master */}
                        <TabPane tab="Sector and Sub-sector Master" key="1">
                            <Table columns={columnsS4_1} dataSource={DataS4_1} bordered />
                        </TabPane>

                        {/* CYP Factor Master */}
                        <TabPane tab="CYP Factor Master" key="2">
                            <Table columns={columnsS4_2} dataSource={DataS4_2} bordered />
                        </TabPane>

                        {/* Continuation Rate Master */}
                        <TabPane tab="Continuation Rate Master" key="3">
                            <Table columns={columnsS4_3} dataSource={DataS4_3} bordered />
                        </TabPane>
                    </Tabs>
                </TabPane>
    
                </Tabs>
                </Card>
                </TabPane>
         {/* )} */}
        </Tabs>
        </>

    );

}

export default EmuCalculation;


/* Below changes were related separate sp calculations which are no more required
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { showLoader } from "@store/actions/loaderAction";
import { getData, postData } from "@services/apiConfig";
import { Card, Button, Form, Row, Col, Input, Select, Divider, Typography } from "antd";
import AlertComponent from "@components/alerts/AlertComponent.js";
import { fetchemumonths, fetchspstatus, emucalculationsp, calculatefinancialaggsp, emumasterdata, fetchbenchmarks, fetchstandarddeviation, fetchcoeffOfdet, calculatereportingrate, calculatestandarddeviation, calculatecoeffofdet } from '../../constants/endpoints';
import { ReloadOutlined } from "@ant-design/icons";
import { validateNoHtmlJsTags } from "@utils/utils.js";

const { Option } = Select;
const { Title } = Typography;


const EmuCalculation = () => {
    const dispatch = useDispatch();

    const userDetailReducer = useSelector(
        (state) => state.basicConfigReducer.userdetails
    );

    const [startYear, setStartYear] = useState('');
    const [endYear, setEndYear] = useState('');
    const [monthsData, setMonthsData] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [startMonth, setStartMonth] = useState('');
    const [endMonth, setEndMonth] = useState('');
    const [emuflag, setEmuFlag] = useState(null);
    const [aggflag, setAggFlag] = useState(null);
    const [categoryData, setCategoryData] = useState([]);
    const [methodData, setMethodData] = useState([]);
    const [reportingRateData, setReportingRateData] = useState([]);
    const [user, setUser] = useState({});
    const [selectedCategory, setSelectedCategory] = useState();
    const [selectedRPCategory, setSelectedRPCategory] = useState(null);
    const [selectedSDCategory, setSelectedSDCategory] = useState(null);
    const [selectedMethod, setSelectedMethod] = useState(null);
    const [benchMarkData, setBenchMarkData] = useState([]);
    const [benchmarkValue, setBenchMarkValue] = useState(null);
    const [sdData, setSDData] = useState([]);
    const [codData, setCODData] = useState([]);
    const [sdValue, setSDValue] = useState(null);
    const [r2Value, setr2Value] = useState(null);
    const [form] = Form.useForm(); // Initialize form instance


    const currentYear = new Date().getFullYear();

    useEffect(() => {
        setUser(userDetailReducer);
    }, [userDetailReducer]);

    const fetchMonthsData = async () => {
        try {
            const payload = {
                url: fetchemumonths,
            };
            dispatch(showLoader(true));
            let res = await getData(payload);
            dispatch(showLoader(false));
            if (res.status === 200) {
                setMonthsData(res.data)
            }
        } catch (err) {
            console.log("error", err);
        }
    }

    const fetchBenchMarkList = async () => {
        try {
            const userid = user._id;

            const payload = {
                url: `fetchbenchmarks?userid=${userid}`,
            };
            dispatch(showLoader(true));
            let res = await getData(payload);
            dispatch(showLoader(false));
            if (res.status === 200) {
                setBenchMarkData(res.data)
            }
        } catch (err) {
            console.log("error", err);
        }
    }

    const fetchStandardDeviationList = async () => {
        try {
            const userid = user._id;

            const payload = {
                url: `fetchstandarddeviation?userid=${userid}`,
            };
            dispatch(showLoader(true));
            let res = await getData(payload);
            dispatch(showLoader(false));
            if (res.status === 200) {
                setSDData(res.data)
            }
        } catch (err) {
            console.log("error", err);
        }
    }

    const fetchCoefficientOfDet = async () => {
        try {
            const userid = user._id;

            const payload = {
                url: `fetchcoeffOfdet?userid=${userid}`,
            };
            dispatch(showLoader(true));
            let res = await getData(payload);
            dispatch(showLoader(false));
            if (res.status === 200) {
                setCODData(res.data)
            }
        } catch (err) {
            console.log("error", err);
        }
    }



    const fetchCurrentSPstatus = async () => {
        try {
            const payload = {
                url: fetchspstatus,
            };
            dispatch(showLoader(true));
            let res = await getData(payload);
            dispatch(showLoader(false));
            if (res.status === 200) {
                res.data.forEach(sp => {
                    if (sp.spname === "sp_master_data_loading" && sp.status === "Y") {
                        setEmuFlag('Y');
                    }
                    if (sp.spname === "sp_monthly_to_financial_aggregation" && sp.status === "Y") {
                        setAggFlag('Y');
                    }
                });

            }
        } catch (err) {
            console.log("error", err);
        }
    }

    const getMasterData = async (value) => {
        const userid = user._id;
        try {
            let payload = {
                url: `${emumasterdata}?getDataof=${value}&userid=${userid}&dropdownData=true`,
            };
            dispatch(showLoader(true));
            let res = await getData(payload);
            dispatch(showLoader(false));
            if (res.status === 200 && res.data.length > 0) {

                if (value === 'Category') {
                    setCategoryData(res.data)
                    // let defaultCategory = res.data[0].id;
                    // let defaultStartYear = res.data[0].startyear;
                    // let defaultEndYear = res.data[0].endyear;
                    // setSelectedCategory(defaultCategory);
                    // setStartYear(defaultStartYear)
                    // setEndYear(defaultEndYear)

                    // Update form fields with default values
                    // form.setFieldsValue({
                    //     categoryid: defaultCategory,
                    //     startYear: defaultStartYear,
                    //     endYear: defaultEndYear,
                    // });

                }
                if (value === 'Method') {
                    setMethodData(res.data);
                }
            }
        } catch (err) {
            dispatch(showLoader(false));
        }
    }



    useEffect(() => {
        const fetchAllData = async () => {

            if (user && user._id) {
                getMasterData("Category");
                getMasterData("Method");
                getMasterData("Reporting Rate");
                fetchMonthsData();
                fetchBenchMarkList();
                fetchStandardDeviationList();
                fetchCoefficientOfDet();
                fetchCurrentSPstatus();
            }
        }
        fetchAllData()
    }, [user]);


    // Handle input change
    const handleYearChange = (e) => {
        setStartYear(e.target.value);
    };

    const handleMonthChange = (value) => {
        const selectedData = monthsData.find(month => month.monthname === value);
        if (selectedData) {
            setStartMonth(selectedData.startmonth);
            setEndMonth(selectedData.endmonth);
        }
        setSelectedMonth(value);
    };

    const handleCategoryChange = (value) => {
        setSelectedCategory(value)
        const result = categoryData.find(item => item.id === value);
        // Extract startyear and endyear if the object is found
        if (result) {
            setStartYear(result.startyear)
            setEndYear(result.endyear)
        } else {
            setStartYear(null)
            setEndYear(null)

        }

    }

    const handleRPCategoryChange = (value) => {
        setSelectedRPCategory(value)
        const result = benchMarkData.find(item => item.categoryid === value);
        if (result) {
            setBenchMarkValue(result.benchmark)
        } else {
            setBenchMarkValue(null)
        }

    }

    const handleSDCategoryChange = (value) => {
        setSelectedSDCategory(value)
        const result = sdData.find(item => item.categoryid === value);
        if (result) {
            setSDValue(result.sdvalue)
        } else {
            setSDValue(null)
        }

    }

    const handleMethodChange = (value) => {
        setSelectedMethod(value)
        const result = codData.find(item => item.methodid === value);
        if (result) {
            setr2Value(result.r2value)
        } else {
            setr2Value(null)
        }
    }

    // Validate year and call stored procedure
    const handleCalculateEMU = async () => {
        // const year = parseInt(startYear, 10);

        if (!selectedCategory) {
            AlertComponent({
                type: "error",
                title: "Error",
                text: "Please select Category ",
                icon: "error",
            });
            return;
        }

        // if (year < 2014 || year > currentYear) {
        //     AlertComponent({
        //         type: "error",
        //         title: "Error",
        //         text: `Start year must be between 2014 and ${currentYear}.`,
        //         icon: "error",
        //     });
        //     return;
        // }

        let payload = {
            url: emucalculationsp,
            body: {
                year: startYear,
                categoryid: selectedCategory,
            },
        }

        dispatch(showLoader(true));
        const res = await postData(payload);
        dispatch(showLoader(false));

        if (res.status === 200) {
            setEmuFlag("N");
            setSelectedCategory(null);
            form.setFieldsValue({ categoryid: null });
        } else {
            AlertComponent({
                type: "error",
                title: "Error",
                text: res.message,
                icon: "error",
            });
        }

    };

    // Validate year and call stored procedure
    const handleCalculateFinancialAgg = async () => {

        if (selectedMonth === '' || startMonth === '' || endMonth === '') {
            AlertComponent({
                type: "error",
                title: "Error",
                text: "Please select Financial Year",
                icon: "error",
            });
            return;
        }

        let payload = {
            url: calculatefinancialaggsp,
            body: {
                monthno: selectedMonth,
                startmonth: startMonth,
                endmonth: endMonth
            },
        }

        dispatch(showLoader(true));
        const res = await postData(payload);
        dispatch(showLoader(false));

        if (res.status === 200) {
            setAggFlag("N");
            setSelectedMonth(null);
            setStartMonth(null)
            setStartYear(null)
        } else {
            AlertComponent({
                type: "error",
                title: "Error",
                text: res.message,
                icon: "error",
            });
        }


    };

    const handleCalculateReportingRate = async () => {

        if (benchmarkValue === '') {
            AlertComponent({
                type: "error",
                title: "Error",
                text: "Please select Category as the bechmark value is empty.",
                icon: "error",
            });
            return;
        }

        let payload = {
            url: calculatereportingrate,
            body: {
                benchmarkvalue: benchmarkValue,
                categoryid: selectedRPCategory,
            },
        }

        dispatch(showLoader(true));
        const res = await postData(payload);
        dispatch(showLoader(false));

        if (res.status === 200) {
            console.log("res", res);
            // setAggFlag("N");
            // setSelectedMonth(null);
            setSelectedRPCategory(null)
            form.setFieldsValue({ rrcategoryid: null });

            setBenchMarkValue(null)
        } else {
            AlertComponent({
                type: "error",
                title: "Error",
                text: res.message,
                icon: "error",
            });
        }


    };

    const handleCalculateStandardDeviation = async () => {

        if (sdValue === '') {
            AlertComponent({
                type: "error",
                title: "Error",
                text: "Please select Category as the standard deviation value is empty.",
                icon: "error",
            });
            return;
        }

        let payload = {
            url: calculatestandarddeviation,
            body: {
                sdvalue: sdValue,
                categoryid: selectedSDCategory,
            },
        }

        dispatch(showLoader(true));
        const res = await postData(payload);
        dispatch(showLoader(false));

        if (res.status === 200) {
            // setAggFlag("N");
            // setSelectedMonth(null);
            setSelectedSDCategory(null)
            form.setFieldsValue({ sdcategoryid: null });
            setSDValue(null)
        } else {
            AlertComponent({
                type: "error",
                title: "Error",
                text: res.message,
                icon: "error",
            });
        }


    };

    const handleCalculateCoeffOfDet = async () => {

        if (r2Value === '') {
            AlertComponent({
                type: "error",
                title: "Error",
                text: "Please select Method as the r2 value is empty.",
                icon: "error",
            });
            return;
        }

        let payload = {
            url: calculatecoeffofdet,
            body: {
                r2value: r2Value,
                methodid: selectedMethod,
            },
        }

        dispatch(showLoader(true));
        const res = await postData(payload);
        dispatch(showLoader(false));

        if (res.status === 200) {
            // setAggFlag("N");
            // setSelectedMonth(null);
            setSelectedMethod(null)
            form.setFieldsValue({ methodid: null });
            setr2Value(null)
        } else {
            AlertComponent({
                type: "error",
                title: "Error",
                text: res.message,
                icon: "error",
            });
        }


    };


    return (
        <>
            <Row gutter={16}>
                <Col xs={24} sm={24} md={12}>
                    <Card size="small" title="EMU Calculations( Based on Input years) " extra={
                        <Button
                            type="text"
                            icon={<ReloadOutlined />}
                            onClick={fetchCurrentSPstatus}
                            title="Refresh"
                            size='small'
                        />
                    }
                    >
                        <Form layout="vertical" form={form}
                        >
                            <Form.Item label="Category" name="categoryid" rules={[{ required: true, message: 'Please select a Category' }]}>
                                <Select onChange={handleCategoryChange} placeholder="Select Category">
                                    <Option value="" disabled>Select</Option>
                                    {categoryData && categoryData.length > 0 && categoryData.map(data => (
                                        <Option key={data.id} value={data.id}>{data.name}</Option>
                                    ))}

                    <Form layout="vertical" >
                        <Form.Item label="Enter Start Year" required
                        rules={[
                            {
                              validator: validateNoHtmlJsTags, // This validator checks for HTML or JavaScript tags
                            },
                          ]}
                        >
                            <Input
                                placeholder="e.g., 2020"
                                value={startYear}
                                onChange={handleYearChange}
                                style={{ width: '100%' }}
                                type="number"
                                required
                            />
                        </Form.Item>
                        <Form.Item>
                            {emuflag !== 'Y' ? (
                                <p style={{ color: '#87CEFA', fontWeight: 'bold' }}>EMU Calculation in progress...</p>
                            ) : (
                                <Button
                                    type="primary"
                                    onClick={handleCalculateEMU}
                                    disabled={emuflag !== 'Y'}
                                >
                                    Calculate
                                </Button>
                                {emuflag !== 'Y' ? (
                                    <p style={{ color: '#87CEFA', fontWeight: 'bold' }}>
                                        EMU Calculation in progress...
                                    </p>
                                ) : null}
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <Card size="small" title="Financial Year Calculation" extra={
                        <Button
                            type="text"
                            icon={<ReloadOutlined />}
                            onClick={fetchCurrentSPstatus}
                            title="Refresh"
                            size='small'
                        />
                    }>

                        <Form layout="vertical">
                            <Form.Item label="Select Financial Year">
                                <Select
                                    placeholder="Select Financial Year"
                                    value={selectedMonth}
                                    onChange={handleMonthChange}
                                >
                                    {monthsData.map((month, index) => (
                                        <Option key={month.monthname} value={month.monthname}>
                                            {`Option ${index + 1} (${month.startmonth} - ${month.endmonth})`}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    type="primary"
                                    onClick={handleCalculateFinancialAgg}
                                    disabled={aggflag !== 'Y'}
                                >
                                    Calculate
                                </Button>
                                {aggflag !== 'Y' ? (
                                    <p style={{ color: '#87CEFA', fontWeight: 'bold' }}>
                                        Financial Year Aggregation in progress...
                                    </p>
                                ) : null}
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row >

            <Row gutter={16}>
                <Col xs={24} sm={24} md={12}>
                    <Card size="small" title="Reporting Rate Bench Mark Calculation" extra={
                        <Button
                            type="text"
                            icon={<ReloadOutlined />}
                            onClick={fetchCurrentSPstatus}
                            title="Refresh"
                            size='small'
                        />
                    }
                    >
                        <Form layout="vertical" form={form}
                        >
                            <Form.Item label="Category" name="rrcategoryid" rules={[{ required: true, message: 'Please select a Category' }]}>
                                <Select onChange={handleRPCategoryChange} placeholder="Select Category">
                                    <Option value="" disabled>Select</Option>
                                    {categoryData && categoryData.length > 0 && categoryData.map(data => (
                                        <Option key={data.id} value={data.id}>{data.name}</Option>
                                    ))}

                                </Select>
                            </Form.Item>
                            {benchmarkValue ? (
                                <>
                                    <Form.Item label="BenchMark Value" required>

                        {selectedMonth && (
                            <>
                                <Form.Item label="Start Month" rules={[
  {
    validator: validateNoHtmlJsTags, // This validator checks for HTML or JavaScript tags
  },
]}>
                                    <Input value={startMonth} readOnly disabled/>
                                </Form.Item>

                                <Form.Item label="End Month"
                                rules={[
                                    {
                                      validator: validateNoHtmlJsTags, // This validator checks for HTML or JavaScript tags
                                    },
                                  ]}
                                >
                                    <Input value={endMonth} readOnly disabled/>
                                </Form.Item>
                            </>
                        )}

                            ) : (
                                <Button
                                    type="primary"
                                    onClick={handleCalculateFinancialAgg}
                                    disabled
                                >
                                    Calculate
                                </Button>
                            )}
                        </Form>
                    </Card>
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <Card size="small" title="Standard Deviation Calculation" extra={
                        <Button
                            type="text"
                            icon={<ReloadOutlined />}
                            onClick={fetchCurrentSPstatus}
                            title="Refresh"
                            size='small'
                        />
                    }
                    >
                        <Form layout="vertical" form={form}
                        >
                            <Form.Item label="Category" name="sdcategoryid" rules={[{ required: true, message: 'Please select a Category' }]}>
                                <Select onChange={handleSDCategoryChange} placeholder="Select Category">
                                    <Option value="" disabled>Select</Option>
                                    {categoryData && categoryData.length > 0 && categoryData.map(data => (
                                        <Option key={data.id} value={data.id}>{data.name}</Option>
                                    ))}

                                </Select>
                            </Form.Item>
                            {sdValue ? (
                                <>
                                    <Form.Item label="Standard Deviation Value" required>

                                        <Input
                                            placeholder="Please enter Standard Deviation Value"
                                            value={sdValue}
                                            type="number"
                                            required
                                            readOnly
                                        />
                                    </Form.Item>

                                    <Button
                                        type="primary"
                                        onClick={handleCalculateStandardDeviation}
                                        disabled={!sdValue}
                                    >
                                        Calculate
                                    </Button>
                                </>

                            ) : (
                                <Button
                                    type="primary"
                                    onClick={handleCalculateFinancialAgg}
                                    disabled
                                >
                                    Calculate
                                </Button>
                            )}
                        </Form>
                    </Card>
                </Col>

            </Row>
            <Row gutter={16}>
                <Col xs={24} sm={24} md={12}>
                    <Card size="small" title="Coefficient of Determination (R²) Calculation" extra={
                        <Button
                            type="text"
                            icon={<ReloadOutlined />}
                            onClick={fetchCurrentSPstatus}
                            title="Refresh"
                            size='small'
                        />
                    }
                    >
                        <Form layout="vertical" form={form}
                        >
                            <Form.Item label="Method" name="methodid" rules={[{ required: true, message: 'Please select a Method' }]}>
                                <Select onChange={handleMethodChange} placeholder="Select Method">
                                    <Option value="" disabled>Select</Option>
                                    {methodData && methodData.length > 0 && methodData.map(data => (
                                        <Option key={data.id} value={data.id}>{data.name}</Option>
                                    ))}

                                </Select>
                            </Form.Item>
                            {r2Value ? (
                                <>
                                    <Form.Item label="R² Value" required>

                                        <Input
                                            placeholder="Please enter R² Value"
                                            value={r2Value}
                                            type="number"
                                            required
                                            readOnly
                                        />
                                    </Form.Item>

                                    <Button
                                        type="primary"
                                        onClick={handleCalculateCoeffOfDet}
                                        disabled={!r2Value}
                                    >
                                        Calculate
                                    </Button>
                                </>

                            ) : (
                                <Button
                                    type="primary"
                                    disabled
                                >
                                    Calculate
                                </Button>
                            )}
                        </Form>
                    </Card>
                </Col>

            </Row>
        </>
    );


}

export default EmuCalculation;

*/
